"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Network = void 0;
const message_1 = require("../message");
const utils_1 = require("../utils");
const async_1 = require("./modules/async");
class Network {
    constructor(url, identity, options) {
        this.url = url;
        this.identity = identity;
        this.options = options !== null && options !== void 0 ? options : { DEBUG: false };
    }
    apply(modules) {
        (0, utils_1.applyMixins)(this, modules);
    }
    async send(req) {
        const cbor = await req.toCborData(this.identity);
        if (this.options.DEBUG) {
            console.log(cbor.toString("hex"));
        }
        const reply = await this.sendEncoded(cbor);
        if (this.options.DEBUG) {
            console.log(reply.toString("hex"));
        }
        // @TODO: Verify response
        const res = await async_1.Async.handleAsyncToken.call(this, message_1.Message.fromCborData(reply));
        return res;
    }
    async sendEncoded(body) {
        const res = await fetch(this.url, {
            method: "POST",
            headers: { "Content-Type": "application/cbor" },
            body,
        });
        const reply = await res.arrayBuffer();
        return Buffer.from(reply);
    }
    async call(method, data, opts = {}) {
        const req = message_1.Message.fromObject(Object.assign({ method, from: this.identity ? await this.identity.getAddress() : undefined, data }, opts));
        return await this.send(req);
    }
}
exports.Network = Network;
